import { IXC_TRADE_V1_TRADE_STATE_ENTITY_NAME } from '@interxfi/api-client/generated/entities/ixc-trade-v1-trade-state';
import { Pill, type PillProps } from '@interxfi/design-system/components/pill/pill';
import { TranslatedText } from '@interxfi/translation/components/translated-text';
import type { IxcTradeV1TradeStatus } from '@interxfi/types/generated/api';
import { getEntityVariant } from '../../util/entity-status-variants';

interface TradeStatusPillProps extends Omit<PillProps, 'children' | 'variant'> {
  status: IxcTradeV1TradeStatus | undefined;
}

export function TradeStatusPill({ isPending, status, ...props }: TradeStatusPillProps) {
  return (
    <Pill isPending={!status || isPending} {...props} variant={getEntityVariant(IXC_TRADE_V1_TRADE_STATE_ENTITY_NAME, status)}>
      <TranslatedText defaultValue={status} i18nKey={{ namespace: 'ixcTradeV1', enumName: 'IxcTradeV1TradeStatus', value: status }} />
    </Pill>
  );
}
